import { ArrowBack, Close, Refresh } from "@mui/icons-material";
import { IconButton, Modal, Stack } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { desktopSx } from "src/utils/styles/modalStyles";

interface Props {
  link: string | null;
  open: boolean;
  onClose: () => void;
  onRefresh: () => void;
}

const DosespotModal = ({ link, open, onClose, onRefresh }: Props) => {
  const navigate = useNavigate();

  if (link == null) return;

  return (
    <Modal open={open} onClose={onClose}>
      <Stack sx={desktopSx} gap={2} width={"80%"} height={"80%"}>
        <Stack direction={"row"} justifyContent={"space-between"}>
          <Stack direction={"row"} gap={2}>
            <IconButton onClick={() => navigate(-1)} sx={{ p: 0 }}>
              <ArrowBack fontSize="large" />
            </IconButton>
            <IconButton onClick={onRefresh} sx={{ p: 0 }}>
              <Refresh fontSize="large" />
            </IconButton>
          </Stack>

          <IconButton onClick={onClose} sx={{ p: 0 }}>
            <Close fontSize="large" />
          </IconButton>
        </Stack>
        <iframe src={link} height={"100%"} width={"100%"}></iframe>
      </Stack>
    </Modal>
  );
};

export default DosespotModal;
